<div
  class="attribute-editor-component rise-text-container te-scrollable-container"
  [shown]="currentView === TextView.MAIN"
>
  <div class="attribute-editor-row" [hidden]="isTextVisible">
    <notification-alert
      id="text-editor-info"
      type="info"
      title="New Feature: Edit text directly on your template."
    >
      <p>
        If you are having trouble,
        <a rv-link appearance="inline" (click)="isTextVisible = true"
          >click here</a
        >.
      </p>
    </notification-alert>
  </div>
  <div class="attribute-editor-row" [shown]="isTextVisible">
    <label for="text-component-input">Text:</label>
    <input
      [hidden]="isMultiline"
      id="text-component-input"
      type="text"
      class="form-control"
      [(ngModel)]="value"
      placeholder="Enter your text"
      (ngModelChange)="save('value')"
    />
    <p [shown]="isMultiline" class="text-sm">Hit enter to add a line break.</p>
    <div [shown]="isMultiline" class="row">
      <div class="col-xs-12">
        <textarea
          id="text-component-input-multiline"
          class="form-control resize-vertical"
          rows="2"
          [(ngModel)]="value"
          placeholder="Enter your text"
          (ngModelChange)="save('value')"
          aria-label="Text (multiline)"
        ></textarea>
      </div>
    </div>
    @if (canShowImproveWithAI()) {
      <button
        rv-button
        variant="secondary"
        type="button"
        id="text-ai-button"
        class="tw-w-full tw-mt-[5px]"
        [attr.aria-label]="textAiButtonLabel"
        (click)="openImproveWithAI()"
      >
        <mat-icon
          svgIcon="ai-gradient"
          aria-hidden="true"
          class="!tw-m-0"
        ></mat-icon>
        <span class="tw-px-[5px]">{{ textAiButtonLabel }}</span>
      </button>
    }
  </div>
  <div class="attribute-editor-row">
    <div
      class="form-group"
      [ngClass]="{ 'has-error': fontFailedToLoad || fontRemovedFromList }"
    >
      <label class="control-label" id="font-picker-label">Font:</label>
      <div
        class="form-control font-picker"
        #fontPicker
        tabindex="0"
        role="combobox"
        aria-labelledby="font-picker-label"
        [attr.aria-expanded]="isFontPickerOpen"
        [attr.aria-controls]="isFontPickerOpen ? 'font-picker-listbox' : null"
        aria-haspopup="listbox"
        [attr.aria-activedescendant]="activeOptionId"
        (click)="onFontPickerClick()"
        (keydown)="onFontPickerKeyDown($event)"
        (blur)="onFontPickerBlur($event)"
      >
        <span class="font-picker-selected" [style.fontFamily]="font">
          {{ fontName }}
        </span>
        <span class="pull-right text-muted"
          ><i
            aria-label="Choose another font"
            class="fa fa-chevron-down font-picker-icon"
          ></i
        ></span>
        @if (isFontPickerOpen) {
          <div
            class="font-picker-dropdown"
            id="font-picker-listbox"
            role="listbox"
            [style.maxHeight.px]="fontPickerMaxHeight"
            id="font-picker-listbox"
            role="listbox"
          >
            <div class="font-picker-block">
              <div
                class="font-picker-option"
                id="font-option-default"
                role="option"
                [style.fontFamily]=""
                [class.selected]="font === defaultFont.font"
                [class.focused]="activeOptionId === 'font-option-default'"
                [attr.aria-selected]="font === defaultFont.font"
                (click)="onFontPickerOptionClick(defaultFont)"
                tabindex="0"
                (keyup.enter)="onFontPickerOptionClick(defaultFont)"
                (keyup.space)="onFontPickerOptionClick(defaultFont)"
              >
                <span class="font-name">{{ defaultFont.name }}</span>
                <mat-icon
                  *ngIf="font === defaultFont.font"
                  class="small bold font-picker-selected-icon"
                  svgIcon="check"
                ></mat-icon>
              </div>
            </div>
            <div class="font-picker-block">
              <div
                class="font-picker-option"
                (click)="onFontPickerAddFontClick()"
                tabindex="0"
                (keyup.enter)="onFontPickerAddFontClick()"
                (keyup.space)="onFontPickerAddFontClick()"
                id="font-option-add-font"
                role="option"
                [class.focused]="activeOptionId === 'font-option-add-font'"
              >
                <mat-icon
                  svgIcon="add-font"
                  class="small icon-left !tw-align-middle"
                ></mat-icon>
                <span class="!tw-align-middle">Add Font</span>
              </div>
            </div>
            <div
              class="font-picker-block"
              role="group"
              aria-labelledby="custom-fonts-label"
            >
              <h3 class="font-picker-category" id="custom-fonts-label">
                Custom Fonts
              </h3>
              @for (
                fontFamily of customFonts;
                track fontFamily;
                let i = $index
              ) {
                <div
                  class="font-picker-option"
                  [ngClass]="{ 'text-danger': fontFamily.failedToLoad }"
                  [style.fontFamily]="fontFamily.font"
                  [class.selected]="font === fontFamily.font"
                  [class.focused]="activeOptionId === 'font-option-custom-' + i"
                  (click)="onFontPickerOptionClick(fontFamily)"
                  [id]="'font-option-custom-' + i"
                  role="option"
                  [attr.aria-selected]="font === fontFamily.font"
                  [title]="fontFamily.name"
                  tabindex="0"
                  (keyup.enter)="onFontPickerOptionClick(fontFamily)"
                  (keyup.space)="onFontPickerOptionClick(fontFamily)"
                  role="option"
                >
                  <span class="font-name">{{ fontFamily.name }}</span>
                  <mat-icon
                    class="small bold font-picker-remove-icon"
                    svgIcon="close"
                    (click)="onRemoveCustomFont(fontFamily, $event)"
                  ></mat-icon>
                  <mat-icon
                    *ngIf="font === fontFamily.font"
                    class="small bold font-picker-selected-icon"
                    svgIcon="check"
                  ></mat-icon>
                </div>
              }
            </div>
            <div
              class="font-picker-block"
              role="group"
              aria-labelledby="google-fonts-label"
            >
              <h3 class="font-picker-category" id="google-fonts-label">
                Google Fonts
              </h3>
              @for (
                fontFamily of googleFonts;
                track fontFamily;
                let i = $index
              ) {
                <div
                  class="font-picker-option"
                  [style.fontFamily]="fontFamily.font"
                  [class.selected]="font === fontFamily.font"
                  [class.focused]="activeOptionId === 'font-option-google-' + i"
                  (click)="onFontPickerOptionClick(fontFamily)"
                  [id]="'font-option-google-' + i"
                  role="option"
                  [attr.aria-selected]="font === fontFamily.font"
                  [title]="fontFamily.name"
                  tabindex="0"
                  (keyup.enter)="onFontPickerOptionClick(fontFamily)"
                  (keyup.space)="onFontPickerOptionClick(fontFamily)"
                >
                  <span class="font-name">{{ fontFamily.name }}</span>
                  <mat-icon
                    *ngIf="font === fontFamily.font"
                    class="small bold font-picker-selected-icon"
                    svgIcon="check"
                  ></mat-icon>
                </div>
              }
            </div>
            <div
              class="font-picker-block"
              role="group"
              aria-labelledby="system-fonts-label"
            >
              <h3 class="font-picker-category" id="system-fonts-label">
                System Fonts
              </h3>
              @for (
                fontFamily of systemFonts;
                track fontFamily;
                let i = $index
              ) {
                <div
                  class="font-picker-option"
                  [style.fontFamily]="fontFamily.font"
                  [class.selected]="font === fontFamily.font"
                  [class.focused]="activeOptionId === 'font-option-system-' + i"
                  (click)="onFontPickerOptionClick(fontFamily)"
                  [id]="'font-option-system-' + i"
                  role="option"
                  [attr.aria-selected]="font === fontFamily.font"
                  [title]="fontFamily.name"
                  tabindex="0"
                  (keyup.enter)="onFontPickerOptionClick(fontFamily)"
                  (keyup.space)="onFontPickerOptionClick(fontFamily)"
                >
                  <span class="font-name">{{ fontFamily.name }}</span>
                  <mat-icon
                    *ngIf="font === fontFamily.font"
                    class="small bold font-picker-selected-icon"
                    svgIcon="check"
                  ></mat-icon>
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if (fontFailedToLoad) {
        <p class="help-block">
          <span
            >The selected font couldn't be loaded. Try re-uploading the font or
            check the source link.</span
          >
        </p>
      }
      @if (fontRemovedFromList) {
        <p class="help-block">
          <span
            >The selected font was removed from the list. You can re-add it by
            clicking on the "Add Font" button.</span
          >
        </p>
      }
    </div>
  </div>
  <div class="attribute-editor-row">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="control-label" for="te-tc-size">Text Size:</label>
          <div
            class="has-feedback"
            [ngClass]="{
              'has-error': !isValidFontSize(),
              'has-success': isValidFontSize(),
            }"
          >
            <input
              type="number"
              class="form-control"
              id="te-tc-size"
              name="te-tc-size"
              placeholder="{{ fontsizePlaceholder }}"
              [(ngModel)]="fontsize"
              [attr.min]="minfontsize"
              [attr.max]="maxfontsize"
              [attr.aria-valuenow]="fontsize"
              [attr.aria-valuemin]="minfontsize"
              [attr.aria-valuemax]="maxfontsize"
              [attr.aria-invalid]="!isValidFontSize()"
              role="spinbutton"
              (ngModelChange)="save('fontsize')"
            />
            @if (!isValidFontSize()) {
              <p class="help-block">
                <span
                  >Please provide a number between {{ minfontsize }} and
                  {{ maxfontsize }}.</span
                >
              </p>
            }
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="control-label" id="te-tc-color-label" for="te-tc-color"
            >Text Color:</label
          >
          <color-picker
            pickerId="te-tc-color"
            placeholderText="Default"
            [(ngModel)]="color"
            (change)="onColorChange()"
            ngDefaultControl
            [ariaLabelledby]="'te-tc-color-label'"
          ></color-picker>
        </div>
      </div>
    </div>
  </div>
  <div class="attribute-editor-row">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label
            id="te-tc-line-height-label"
            class="control-label"
            for="te-tc-line-height"
            >Line Height:</label
          >
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
            class="tw-w-full"
          >
            <mat-select
              id="te-tc-line-height"
              [(ngModel)]="lineheight"
              (ngModelChange)="save('lineheight')"
              aria-labelledby="te-tc-line-height-label"
            >
              <mat-option value="">Default</mat-option>
              <mat-option value="1">Single</mat-option>
              <mat-option value="1.15">1.15</mat-option>
              <mat-option value="1.5">1.5</mat-option>
              <mat-option value="2">Double</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="control-label" for="te-tc-letter-spacing"
            >Letter Spacing:</label
          >
          <input
            id="te-tc-letter-spacing"
            type="number"
            class="form-control"
            [(ngModel)]="letterspacing"
            placeholder="Default"
            [attr.aria-valuenow]="letterspacing"
            role="spinbutton"
            (ngModelChange)="save('letterspacing')"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="attribute-editor-row">
    <div class="form-group">
      <label class="control-label" id="te-tc-formatting-label">Options:</label>
      <div
        class="formatting-options"
        role="group"
        aria-labelledby="te-tc-formatting-label"
      >
        @for (fo of formattingOptions; track fo; let foIndex = $index) {
          <div
            tabindex="0"
            class="formatting-option"
            [class.selected]="isFormatSelected(fo)"
            [class.middle]="foIndex === 1"
            (click)="onFormattingClick(fo)"
            (keyup.enter)="onFormattingClick(fo)"
            (keyup.space)="onFormattingClick(fo)"
            [attr.aria-label]="fo + ' formatting'"
            [attr.aria-checked]="isFormatSelected(fo)"
            role="checkbox"
          >
            <i aria-hidden="true" class="fa fa-{{ fo }}"></i>
            <span class="tw-sr-only">{{ fo | titlecase }}</span>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="attribute-editor-row">
    <div class="form-group">
      <label class="control-label" id="te-tc-alignment-label">Alignment:</label>
      <div
        class="formatting-options"
        role="radiogroup"
        aria-labelledby="te-tc-alignment-label"
      >
        @for (ao of alignmentOptions; track ao; let aoIndex = $index) {
          <div
            tabindex="0"
            class="formatting-option"
            [class.selected]="isAlignmentSelected(ao)"
            [class.middle]="aoIndex === 1"
            (click)="onAlignmentClick(ao)"
            (keyup.enter)="onAlignmentClick(ao)"
            (keyup.space)="onAlignmentClick(ao)"
            [attr.aria-label]="'Align text ' + ao"
            [attr.aria-checked]="isAlignmentSelected(ao)"
            role="radio"
          >
            <span class="tw-sr-only">{{ 'Align text ' + ao }}</span>
            <i aria-hidden="true" class="fa fa-align-{{ ao }}"></i>
            <span class="tw-sr-only">Align {{ ao | titlecase }}</span>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="attribute-editor-row" [shown]="showPosition">
    <div class="form-group">
      <label
        id="te-tc-position-label"
        class="control-label u_margin-sm-top"
        for="te-tc-position"
        >Position</label
      >
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="tw-w-full"
      >
        <mat-select
          id="te-tc-position"
          [(ngModel)]="position"
          (ngModelChange)="save('position')"
          aria-labelledby="te-tc-position-label"
        >
          @for (po of positionOptions; track po) {
            <mat-option [value]="po">{{ po.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<template-component-text-ai
  [shown]="currentView === TextView.IMPROVE_WITH_AI"
  [value]="value"
  [componentId]="componentId"
  (textGenerated)="onAiTextGenerated($event)"
></template-component-text-ai>
